import React from 'react';
import { Separator } from './ui/separator';
import { Heart, Linkedin, Github, Mail } from 'lucide-react';
import { portfolioData } from '../data/mock';

const Footer = () => {
  const { personal } = portfolioData;
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-slate-950 border-t border-slate-800 py-8">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Main Footer Content */}
          <div className="flex flex-col md:flex-row justify-between items-center gap-6 mb-6">
            {/* Logo & Copyright */}
            <div className="text-center md:text-left">
              <button
                onClick={scrollToTop}
                className="text-2xl font-bold text-white hover:text-blue-400 transition-colors mb-2 inline-block"
              >
                <span className="text-blue-400">&lt;</span>
                JP
                <span className="text-blue-400">/&gt;</span>
              </button>
              <p className="text-sm text-gray-400">
                © {currentYear} {personal.name}. All rights reserved.
              </p>
            </div>

            {/* Quick Links */}
            <div className="flex flex-wrap justify-center gap-6 text-sm">
              <a
                href="#about"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                About
              </a>
              <a
                href="#experience"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                Experience
              </a>
              <a
                href="#skills"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                Skills
              </a>
              <a
                href="#projects"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                Projects
              </a>
              <a
                href="#contact"
                className="text-gray-400 hover:text-blue-400 transition-colors"
              >
                Contact
              </a>
            </div>

            {/* Social Links */}
            <div className="flex gap-4">
              <a
                href={personal.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-slate-900 hover:bg-blue-600/20 border border-slate-800 hover:border-blue-500 rounded-lg text-gray-400 hover:text-blue-400 transition-all duration-300"
                aria-label="LinkedIn"
              >
                <Linkedin size={20} />
              </a>
              <a
                href={personal.github}
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 bg-slate-900 hover:bg-blue-600/20 border border-slate-800 hover:border-blue-500 rounded-lg text-gray-400 hover:text-blue-400 transition-all duration-300"
                aria-label="GitHub"
              >
                <Github size={20} />
              </a>
              <a
                href={`mailto:${personal.email}`}
                className="p-2 bg-slate-900 hover:bg-blue-600/20 border border-slate-800 hover:border-blue-500 rounded-lg text-gray-400 hover:text-blue-400 transition-all duration-300"
                aria-label="Email"
              >
                <Mail size={20} />
              </a>
            </div>
          </div>

          <Separator className="bg-slate-800 mb-6" />

          {/* Bottom Section */}
          <div className="text-center">
            <p className="text-sm text-gray-500 flex items-center justify-center gap-2 flex-wrap">
              <span>Designed & Built with</span>
              <Heart size={16} className="text-red-500 inline animate-pulse" fill="currentColor" />
              <span>by {personal.name}</span>
            </p>
            <p className="text-xs text-gray-600 mt-2">
              QA/SDET Leader | Engineering Manager | Automation Expert
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;